// extracted by mini-css-extract-plugin
export default {"root":"ActionBar_root__0q3h2"};